import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { App, Button, Drawer, Form, Input, Space, Switch, Table, Tag, Typography } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, apiError } from '@/lib/api';
import { useAuthStore } from '@/lib/auth-store';
export function CategoriesPage() {
    const { message } = App.useApp();
    const qc = useQueryClient();
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const [drawer, setDrawer] = useState({ open: false });
    const [form] = Form.useForm();
    const q = useQuery({
        queryKey: ['toko-categories'],
        queryFn: async () => (await api.get('/toko/categories')).data,
    });
    const createMut = useMutation({
        mutationFn: async (v) => (await api.post('/toko/categories', v)).data,
        onSuccess: () => {
            message.success('Kategori ditambahkan');
            qc.invalidateQueries({ queryKey: ['toko-categories'] });
            setDrawer({ open: false });
        },
        onError: (e) => message.error(apiError(e)),
    });
    const patchMut = useMutation({
        mutationFn: async ({ id, body }) => (await api.patch(`/toko/categories/${id}`, body)).data,
        onSuccess: () => {
            message.success('Kategori diperbarui');
            qc.invalidateQueries({ queryKey: ['toko-categories'] });
            setDrawer({ open: false });
        },
        onError: (e) => message.error(apiError(e)),
    });
    const cols = [
        { title: 'Nama', dataIndex: 'name' },
        { title: 'Deskripsi', dataIndex: 'description' },
        {
            title: 'Produk Aktif',
            dataIndex: 'product_count',
            width: 120,
            render: (n) => _jsx(Tag, { color: "blue", children: n }),
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            width: 100,
            render: (a) => (a ? _jsx(Tag, { color: "success", children: "Aktif" }) : _jsx(Tag, { children: "Nonaktif" })),
        },
        {
            title: 'Aksi',
            width: 90,
            render: (_, r) => hasPerm('product:edit') && (_jsx(Button, { size: "small", icon: _jsx(EditOutlined, {}), onClick: () => { setDrawer({ open: true, row: r }); form.setFieldsValue(r); } })),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Kategori Produk" }), hasPerm('product:create') && (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => { form.resetFields(); setDrawer({ open: true }); }, children: "Tambah Kategori" }))] }), _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: { pageSize: 20 }, size: "middle" }), _jsx(Drawer, { open: drawer.open, onClose: () => setDrawer({ open: false }), title: drawer.row ? 'Edit Kategori' : 'Tambah Kategori', width: 420, destroyOnClose: true, extra: _jsx(Button, { type: "primary", loading: createMut.isPending || patchMut.isPending, onClick: () => form.validateFields().then((v) => {
                        if (drawer.row)
                            patchMut.mutate({ id: drawer.row.id, body: v });
                        else
                            createMut.mutate(v);
                    }), children: "Simpan" }), children: _jsxs(Form, { form: form, layout: "vertical", preserve: false, children: [_jsx(Form.Item, { name: "name", label: "Nama", rules: [{ required: true }], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "description", label: "Deskripsi", children: _jsx(Input.TextArea, { rows: 3 }) }), drawer.row && (_jsx(Form.Item, { name: "is_active", label: "Aktif", valuePropName: "checked", children: _jsx(Switch, {}) }))] }) })] }));
}
